export enum ColorCodeEnum {
  Default = 'Default',
  DiffFromNormalSB = 'DiffFromNormalSB',
  DiffFromNormalMB = 'DiffFromNormalMB',
  DiffFromNormalB = 'DiffFromNormalB',
  DiffFromNormalSlightB = 'DiffFromNormalSlightB',
  DiffFromNormal = 'DiffFromNormal',
  DiffFromNormalSlightA = 'DiffFromNormalSlightA',
  DiffFromNormalA = 'DiffFromNormalA',
  DiffFromNormalMA = 'DiffFromNormalMA',
  DiffFromNormalSA = 'DiffFromNormalSA',
  DiffValAboveZero = 'DiffValAboveZero',
  DiffValBelowZero = 'DiffValBelowZero',
  DiffAboveZero = 'DiffAboveZero',
  DiffBelowZero = 'DiffBelowZero',
  ForecastValueFeelsLikeDarkBlue = 'ForecastValueFeelsLikeDarkBlue',
  ForecastValueFeelsLikeLightBlue = 'ForecastValueFeelsLikeLightBlue',
  ForecastValueFeelsLikeWhite = 'ForecastValueFeelsLikeWhite',
  ForecastValueFeelsLikeLightRed = 'ForecastValueFeelsLikeLightRed',
  ForecastValueFeelsLikeDarkRed = 'ForecastValueFeelsLikeDarkRed',
  PrecipAmountInchRange1 = 'PrecipAmountInchRange1',
  PrecipAmountInchRange2 = 'PrecipAmountInchRange2',
  PrecipAmountInchRange3 = 'PrecipAmountInchRange3',
  PrecipAmountInchRange4 = 'PrecipAmountInchRange4',
  PrecipAmountInchRange5 = 'PrecipAmountInchRange5',
  PrecipAmountMMRange1 = 'PrecipAmountMMRange1',
  PrecipAmountMMRange2 = 'PrecipAmountMMRange2',
  PrecipAmountMMRange3 = 'PrecipAmountMMRange3',
  PrecipAmountMMRange4 = 'PrecipAmountMMRange4',
  PrecipAmountMMRange5 = 'PrecipAmountMMRange5',
  PrecipAmountDiffRange1 = 'PrecipAmountDiffRange1',
  PrecipAmountDiffRange2 = 'PrecipAmountDiffRange2',
  DiffFromPrevPopSmall = 'DiffFromPrevPopSmall',
  DiffFromPrevPopLarge = 'DiffFromPrevPopLarge',
  DiffFromPrevPopMedium = 'DiffFromPrevPopMedium',
  POPDiffAboveZero = 'POPDiffAboveZero',
  POPDiffBelowZero = 'POPDiffBelowZero',
}
